import { contextFactory } from '@frontend/design-system';

export type WaitlistTrayContextType = {
  onClose: () => void;
  // Use in new waitlist flow (when calendar slot selected)
  selectedLocationId?: string;
  selectedDate?: string;
  selectedTime?: string;
  selectedProviderId?: string;
};

export const [WaitlistTrayContext, useWaitlistTrayContext] = contextFactory<WaitlistTrayContextType>();
